import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../../core/services/auth.service';
import {environment} from '../../../environments/environment';

const hideCharts = environment.hideCharts;

@Injectable({providedIn: 'root'})
export class KfChartsGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    let allowed = false;

    if (this.authService.isLoggedIn()) {
      if (this.authService.userHasAnyRole(['WF_ADMIN', 'COLLECTED', 'ALL'])) {
        if (state.url.includes('cost') || this.router.url.includes('recycle')) {
          allowed = this.authService.userHasAnyRole(['WF_ADMIN', 'ALL']);
        } else {
          allowed = this.authService.userHasAnyRole(['WF_ADMIN', 'COLLECTED', 'ALL']);
        }
      }
      if (!allowed) {
        this.router.navigate(['forbidden']);
      }
      return allowed;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}
